import React from 'react'
import { Form, type FormValues } from '@s4l/ds'
import FilterRatings from './FilterRatings'
import { SearchFilters } from '@s4l/stayforlong/property/SearchFilters'
import FilterAccommodation from './FilterAccommodation'
import { withErrorBoundary } from '@s4l/utils/hocs/withErrorBoundary'
import FilterStars from './FilterStars'
import FilterFacilities from './FilterFacilities'
import FilterPricing from './FilterPricing'
import type { ListOfPriceDistribution } from '@s4l/stayforlong/property/ListOfPriceDistribution'
import FilterMealPlans from './FilterMealPlans'
import FilterThemes from './FilterThemes'
import FilterPaymentAndCancellation from './FilterPaymentAndCancellation'
import FilterLayout from './FilterLayout'

interface ISearchFiltersProps {
  OnFilterChange: (filters: FormValues) => void
  defaultFiltersJSON: ReturnType<SearchFilters['toJSON']>
  listOfPriceDistributionJSON: Parameters<(typeof ListOfPriceDistribution)['fromJSON']>[0]
  showExtendedFilters?: boolean
}

const SearchFiltersComponent = ({
  OnFilterChange,
  defaultFiltersJSON,
  listOfPriceDistributionJSON,
  showExtendedFilters = false,
}: ISearchFiltersProps) => {
  const defaultFilters = SearchFilters.fromJSON(defaultFiltersJSON).toPrimitives()

  return (
    <Form
      debounceOnChange={300}
      onChange={OnFilterChange}
      defaultValue={defaultFilters}
      ignore={['minIndex', 'maxIndex']}
    >
      <FilterLayout>
        <FilterPricing
          defaultMaxPrice={defaultFilters.maxPrice}
          defaultMinPrice={defaultFilters.minPrice}
          listOfPriceDistributionJSON={listOfPriceDistributionJSON}
        />
        <Form.Separator />
        <FilterRatings />
        <Form.Separator />
        <FilterStars />
        <Form.Separator />
        {showExtendedFilters && (
          <>
            <FilterMealPlans />
            <Form.Separator />
            <FilterPaymentAndCancellation />
            <Form.Separator />
          </>
        )}
        <FilterAccommodation />
        <Form.Separator />
        <FilterFacilities />
        <Form.Separator />
        <FilterThemes />
        <Form.Separator />
      </FilterLayout>
    </Form>
  )
}

SearchFiltersComponent.displayName = 'SearchFilters'

export default withErrorBoundary(SearchFiltersComponent)
